import React, { useMemo } from "react";
import { Divider } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles(() => ({
  cart: {
    display: "grid",
    alignContent: "start",
    width: "100%",
    height: "fit-content",
    backgroundColor: "rgb(245, 245, 245)",
    padding: "1.5rem 1.75rem",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    "@media screen and (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      padding: "1rem",
    },
  },
  list: {
    listStyle: "none",
    padding: 0,
  },
  listWrapper: {
    display: "flex",
    gap: "1rem",
  },
  name: {
    fontWeight: 500,
  },
  ticketOwner: {
    fontWeight: 400,
  },
  price: {
    fontWeight: 500,
  },
  wrapper: {
    width: "100%",
  },
  bottomWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  quantity: {
    fontSize: "0.875rem",
  },
}));

const OrderList = ({ language, articles }) => {
  const { classes } = useStyles();

  const onlyArticles = useMemo(() => {
    return articles.filter((el) => !el.isFee);
  }, [articles]);

  if (!articles) return null;
  return (
    <div className={classes.cart}>
      <h2>{language.Order}</h2>
      <ul className={classes.list}>
        {onlyArticles &&
          onlyArticles.map((item, i) => (
            <li className={classes.list} key={i}>
              <div className={classes.listWrapper}>
                <div className={classes.wrapper}>
                  <div className={classes.nameWrapper}>
                    <span className={classes.name}>{item.name}</span>
                    {item?.ticketOwners?.[0]?.name ? (
                      <small className={classes.ticketOwner}>
                        {item?.ticketOwners?.[0]?.name}
                      </small>
                    ) : (
                      <small />
                    )}
                  </div>
                  <div>
                    {item.info ? (
                      <small className={classes.ticketOwner}>{item.info}</small>
                    ) : (
                      <small />
                    )}
                  </div>
                  <div className={classes.bottomWrapper}>
                    <span className={classes.quantity}>
                      {language.Cart_Quantity}: {item?.quantity}
                    </span>
                    <span className={classes.price}>
                      {item.displayPriceInclVat}
                    </span>
                  </div>
                </div>
              </div>
              {i + 1 !== articles.length && (
                <Divider my="lg" style={{ borderTopColor: "#E7E9EC" }} />
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default OrderList;
